import { apiInterceptor } from 'utils/apiInterceptor';
export async function UpdateChannel(projectId, channelId, inputs) {
    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API_V2}/manager/livestream/channels/${channelId}?projectId=${projectId}`,
        {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(inputs),
        }
    );
    return await response.json();
}
